export function isConnectionBusy(connection: any): boolean {
  try {
    return !!connection?.isLoadingAccounts || !!connection?.isPersisting || connection?.processingState === 'processing';
  } catch {
    return false;
  }
}
